import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import OutsideClickHandler from 'react-outside-click-handler';
import { CcIcon } from '@utp/components-react';
import NavigationMonth from './components/NavigationMonth';
import { DaysWeek, DaysMonth, StatusWeek } from './components';
import Block from '../Block';
import Label from '../Label';
import TextHelper from '../../../core/helpers/TextHelper';

const DatepickerWrap = styled.div`
  background: #fff;
  width: 100%;
  min-width: 296px;
  height: auto;
  // padding: 24px 8px;
  min-height: 352px;
  @media (max-width: 768px) {
    position: fixed;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 9;
    // padding: 24px 32px;
  }
`;
const DatepickerContent = styled.div`
  padding: 24px 8px;
  @media (max-width: 768px) {
    padding: 24px 32px;
  }
`;
const DropDownWrapper = styled.div`
  height: 42px;
  overflow: visible;
  position: relative;
  > div {
    cursor: default;
  }
  cc-icon.chevron-up,
  cc-icon.chevron-down {
    display: block;
    cursor: pointer;
    color: var(--interaction-primary);
  }

  .menu {
    position: relative;
    display: none;
  }
  .menu.active {
    display: block;
  }
  .selected {
    padding: 7px 8px 7px 18px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid var(--neutrals-neutral01);
    min-width: 235px;
    max-width: 235px;
    width: auto;
    // justify-content: space-between;
    font-size: 1.4rem;
    font-weight: bold;
    color: var(--neutral-03);
  }
  .selected:hover {
    border: 1px solid var(--interaction-primary);
  }
  .monthName {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    // margin-left: 8px;
    // margin-right: 8px;
  }

  .menu-container {
    min-width: 153px;
    width: auto;
    color: black;
    list-style: none;
    padding: 4px 0px;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #fff;
    color: var(--neutral-03);
    margin-top: 0.8rem;
    border-radius: 0.4rem;
    border-width: 0;
    -webkit-box-shadow: 0 4px 16px -8px #b0c0ca;
    box-shadow: 0 4px 16px -8px #b0c0ca;
    -webkit-overflow-scrolling: touch;
    will-change: scroll-position;
    z-index: 14;
    position: absolute;
  }

  .item {
    position: relative;
    font-size: 14px;
    font-weight: 300;
    margin: 0;
    color: var(--neutral-03);
    background-color: #fff;
  }
  .item.active {
    background-color: #eaf1f5;
    color: var(--text-text01);
    font-weight: bold;
  }
  .item:hover {
    background-color: var(--background-background03);
    color: var(--neutral-03);
    font-weight: bold;
  }

  .selected:focus {
    outline: 0px solid #fff;
    outline-offset: -4px;
  }

  .item .item-link {
    display: inline-block;
    border: none;
    margin: 0;
    text-decoration: none;
    cursor: default;
    text-align: left;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: 0px solid #fff;
    outline-offset: -4px;
    padding: 0;
    width: 100%;
    padding: 10px 16px;
  }

  .item .item-link:focus {
    outline: 0px solid #fff;
    outline-offset: -4px;
  }

  cc-icon {
    border-width: 0;
    color: var(--interaction-primary);
    display: flex;
  }
  div.selected cc-icon.chevron-up,
  div.selected cc-icon.chevron-down {
    display: flex;
  }
  cc-icon.calendar {
    border-width: 0;
    color: var(--neutrals-neutral02);
    display: flex;
  }

  label {
    display: flex;
  }

  @media (max-width: 768px) {
    // max-width: 104px;
    div.selected {
      min-width: auto;
      // max-width: 104px;
      padding: 8px 12px 8px 12px;
    }
    cc-icon.calendar {
      width: 20px;
      height: 20px;
    }
    div.selected cc-icon.chevron-up,
    div.selected cc-icon.chevron-down {
      display: none;
    }
    div.selected label {
      font-weight: bold;
      // margin-left: 5px;
    }
  }
`;
interface IMenuList {
  desc?: string;
  end?: number;
  id: number;
  start?: number;
}

interface Props {
  menu: Array<IMenuList>;
  value: any;
  handleSelectDate: (date: Date) => void;
  today: Date;
  selectedDate: Date;
  dates: Date[];
  isCGT: boolean;
}

function Datepicker(props: Readonly<Props>) {
  const { menu, value, handleSelectDate, today, selectedDate, dates, isCGT } =
    props;
  const [openmenu, setOpenmenu] = useState(false);
  const daysWeek = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
  const monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Setiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];
  if (!dates) return null;
  const datesFirstDay = dates[0];
  const datesLastDay = dates[6];

  const [firstDayOfWeek] = useState(
    new Date(datesFirstDay.setDate(datesFirstDay.getDate()))
  );
  const [lastDayOfWeek] = useState(
    new Date(datesLastDay.setDate(datesLastDay.getDate()) + 1)
  );

  const isToday = (a: any, b: any) => {
    let c = false;
    if (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    ) {
      c = true;
    }
    return c;
  };

  const getAllDaysBetweenRange = (startD: any, endD: any) => {
    const allDates = [];
    for (let dt = new Date(startD); dt <= endD; dt.setDate(dt.getDate() + 1)) {
      const thisDate = new Date(dt);
      allDates.push(thisDate);
    }
    return allDates;
  };

  const getSelectedDay = (a: any, b: any) => {
    let c = false;
    if (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    ) {
      c = true;
    }
    return c;
  };

  const getIsBeforeToday = (a: any) =>
    new Date(a.toDateString()) < new Date(today.toDateString());

  const getIsInsideEdges = (startD: any, endD: any, dateD: any) => ({
    isFirstDayWeek:
      startD.getFullYear() === dateD.getFullYear() &&
      startD.getMonth() === dateD.getMonth() &&
      startD.getDate() === dateD.getDate(),
    isLastDayWeek:
      endD.getFullYear() === dateD.getFullYear() &&
      endD.getMonth() === dateD.getMonth() &&
      endD.getDate() === dateD.getDate()
  });

  const getWeek = (fromDate: Date) => {
    const sunday = new Date(
      fromDate.setDate(fromDate.getDate() - fromDate.getDay())
    );
    const result = [new Date(sunday)];
    while (sunday.setDate(sunday.getDate() + 1) && sunday.getDay() !== 0) {
      result.push(new Date(sunday));
    }
    return result;
  };

  const fdoweek = getWeek(new Date())[1];
  const ldoweekF = getWeek(new Date())[6];
  const ldoweek = new Date(ldoweekF);
  ldoweek.setDate(ldoweek.getDate() + 1);

  const someInitialRange = getAllDaysBetweenRange(fdoweek, ldoweek);

  const isInsideWeek = (sdates: any, somedate: any) =>
    somedate >= sdates[0] && somedate <= sdates[sdates.length - 1];

  const getObjectDays = (dts: any) => {
    let ObjDays = [];
    let fdw: any;
    let ldw: any;
    if (dates !== undefined && dates.length) {
      const s = new Date(dates[0]);
      const e = new Date(dates[6]);
      fdw = new Date(s.setDate(s.getDate()));
      ldw = new Date(e.setDate(e.getDate()) + 1);
    }
    ObjDays = dts.map((item: any) => ({
      label: item,
      isToday: isToday(item, today),
      isInsideWeek: isInsideWeek(someInitialRange, item),
      isFirstDayWeek:
        fdw !== undefined
          ? getIsInsideEdges(firstDayOfWeek, lastDayOfWeek, item).isFirstDayWeek
          : false,
      isLastDayWeek:
        ldw !== undefined
          ? getIsInsideEdges(firstDayOfWeek, lastDayOfWeek, item).isLastDayWeek
          : false,
      isBeforeToday: getIsBeforeToday(item)
    }));
    return ObjDays;
  };

  const clbl = menu?.find((m: any) => m.id === value);
  const menuToggle = () => {
    setOpenmenu(!openmenu);
  };

  const getWeekCurrent = (
    WeekId: any,
    WeekStart: any,
    WeekEnd: any,
    IsResponsive: any,
    IsTopLabel: any
  ) => {
    let weekLabel;
    let weekNumber;
    let weeKRange;
    const weekDesc = `Sem${WeekId !== null ? ` ${WeekId}` : ''}`;
    if (IsResponsive) {
      weekNumber = WeekId === null || isCGT ? '' : weekDesc;
      if (IsTopLabel) {
        weekNumber = isCGT ? '' : weekDesc; // WeekId !== null ? weekDesc : '';
      }

      weeKRange = `${WeekStart.getDate()} ${TextHelper.truncateString(
        monthNames[WeekStart.getMonth()],
        4
      )} - ${WeekEnd.getDate()} ${TextHelper.truncateString(
        monthNames[WeekEnd.getMonth()],
        4
      )}`;
      weekLabel = `${weekNumber}`;
    } else {
      weekNumber = isCGT ? '' : `${weekDesc}: `;
      weeKRange = `${WeekStart.getDate()} ${TextHelper.truncateString(
        monthNames[WeekStart.getMonth()],
        4
      )} - ${WeekEnd.getDate()} ${TextHelper.truncateString(
        monthNames[WeekEnd.getMonth()],
        4
      )}`;
      weekLabel = `${weekNumber} ${weeKRange}`;
    }

    return weekLabel;
  };

  ///
  const getRangeDays = (d: any) => {
    const month = d.getMonth();
    const year = d.getFullYear();

    const rangeDays = {
      FirstDay: new Date(year, month, 1),
      LastDay: new Date(year, month + 1, 0)
    };

    return rangeDays;
  };

  const [firstDay, setFirstDay] = useState(getRangeDays(today).FirstDay); // new Date(date2.getFullYear(), date2.getMonth(), 1);
  const [lastDay, setLastDay] = useState(getRangeDays(today).LastDay); // new Date(date2.getFullYear(), date2.getMonth() + 1, 0);
  const daylist = getObjectDays(getAllDaysBetweenRange(firstDay, lastDay));
  const [daysMonth, setDaysMonth] = useState(daylist);

  const [currentMonthNumber, setCurrentMonthNumber] = useState(
    new Date().getMonth()
  );
  const [currentMonth, setCurrentMonth] = useState(
    monthNames[new Date().getMonth()]
  );

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setCurrentYear(selectedDate.getFullYear());
    setCurrentMonthNumber(selectedDate.getMonth());
    setCurrentMonth(monthNames[selectedDate.getMonth()]);
    const someDayOfNextMonth = new Date(selectedDate);
    const nRange = getRangeDays(someDayOfNextMonth);
    setFirstDay(nRange.FirstDay);
    setLastDay(nRange.LastDay);
    const nListMonthDays = getObjectDays(
      getAllDaysBetweenRange(nRange.FirstDay, nRange.LastDay)
    );
    setDaysMonth(nListMonthDays);
  }, [openmenu]);

  const onNextMonth = () => {
    let cmn = currentMonthNumber + 1;

    if (cmn > 11) {
      cmn = 0;
      setCurrentYear(currentYear + 1);
    }

    setCurrentMonth(monthNames[cmn]);
    setCurrentMonthNumber(cmn);

    const nextDay = lastDay;
    const someDayOfNextMonth = new Date(nextDay.setDate(nextDay.getDate() + 1));
    const nRange = getRangeDays(someDayOfNextMonth);
    setFirstDay(nRange.FirstDay);
    setLastDay(nRange.LastDay);
    const nListMonthDays = getObjectDays(
      getAllDaysBetweenRange(nRange.FirstDay, nRange.LastDay)
    );
    setDaysMonth(nListMonthDays);
  };
  const onPrevMonth = () => {
    let cmn = currentMonthNumber - 1;
    if (cmn < 0) {
      cmn = 11;
      setCurrentYear(currentYear - 1);
    }
    setCurrentMonth(monthNames[cmn]);
    setCurrentMonthNumber(cmn);

    const prevDay = firstDay;
    const someDayOfPrevMonth = new Date(prevDay.setDate(prevDay.getDate() - 1));
    const nRange2 = getRangeDays(someDayOfPrevMonth);

    setFirstDay(nRange2.FirstDay);
    setLastDay(nRange2.LastDay);
    const nListMonthDays2 = getObjectDays(
      getAllDaysBetweenRange(nRange2.FirstDay, nRange2.LastDay)
    );
    setDaysMonth(nListMonthDays2);
  };

  const onSelectDate = (d: any) => {
    handleSelectDate(d);
    const ndaysMonth = daysMonth.map((item: any) => ({
      ...item,
      isSelectedDay: getSelectedDay(item.label, d)
    }));
    setDaysMonth(ndaysMonth);
    setTimeout(() => {
      setOpenmenu(false);
    }, 300);
  };

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setOpenmenu(false);
      }}
    >
      <DropDownWrapper>
        <Block className="selected" onClick={() => menuToggle()}>
          <CcIcon className="calendar" name="calendar" size={22} />
          <Block className="monthName">
            {getWeekCurrent(
              clbl ? clbl?.id : null,
              dates[0],
              dates[6],
              isMobile,
              false
            ) !== '' && (
              <Label
                marginLeft={5}
                size={14}
                text={getWeekCurrent(
                  clbl ? clbl?.id : null,
                  dates[0],
                  dates[6],
                  isMobile,
                  false
                )}
              />
            )}
            {openmenu ? (
              <CcIcon className="chevron-up" name="chevron-up" />
            ) : (
              <CcIcon className="chevron-down" name="chevron-down" />
            )}
          </Block>
        </Block>
        <Block className={`menu ${openmenu ? 'active' : ''}`} role="menu">
          <Block className="menu-container">
            <DatepickerWrap>
              <StatusWeek
                status={getWeekCurrent(
                  clbl ? clbl?.id : null,
                  dates[0],
                  dates[6],
                  false,
                  true
                )}
                onClose={() => {
                  setOpenmenu(false);
                }}
              />
              <DatepickerContent>
                <NavigationMonth
                  currentMonth={currentMonth}
                  currentYear={currentYear}
                  onNextMonth={onNextMonth}
                  onPrevMonth={onPrevMonth}
                />
                <DaysWeek days={daysWeek} />
                <DaysMonth
                  days={daysMonth}
                  onSelectDate={onSelectDate}
                  selectedDate={selectedDate}
                />
              </DatepickerContent>
            </DatepickerWrap>
          </Block>
        </Block>
      </DropDownWrapper>
    </OutsideClickHandler>
  );
}

export default Datepicker;
